<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="compareciente-modal" title="" hide-footer id="modalC" size="xl">
      <AgregaSolicitante
        :current-solicitante="currentCompareciente"
        :max-number-of-representantes="1"
        :proceso="2"
        @submit-form="putCompareciente"
      />
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere remover el solicitante?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteCompareciente">OK</b-button>
    </b-modal>

    <h4 class="cardD">Información de los Solicitantes</h4>
    <label class="fs-6 text-black-50 text-uppercase">Agregar solicitantes</label>

    <div class="mt-2">
      <label for="btn-add">Nuevo</label>
      <b-button
        variant="success"
        class="btn-fill spaceL"
        size="sm"
        @click="addCompareciente"
        :disabled="!canAddSolicitanteComputed || globalDisable"
        id="btn-add"
      >
        +
      </b-button>
    </div>

    <div class="mt-2">
      <label>Ó</label>
    </div>

    <div class="mt-2">
      <div>
        <label for="select-comparecientes">Existente (solo aparecerán solicitantes de procesos concluídos)</label>
      </div>
      <div class="col-12">
        <select
          id="select-comparecientes"
          class="custom-select"
          :disabled="!canAddSolicitanteComputed || globalDisable"
          v-model="selectedSolicitante"
        >
          <option v-for="option in comparecientesComboStore.getSelectOptions" :key="option.index" :value="option.index">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="notificacion.solicitantes.length > 0" class="mt-5">
      <b-table ref="table" hover :fields="fieldsCuadro" :items="notificacion.solicitantes">
        <template #cell(nombreCompleto)="{ item }">
          {{ displaytext(item) }}
        </template>
        <template #cell(acciones)="{ item }">
          <b-button
            v-if="!item.existente && !item.representante"
            variant="warning"
            size="sm"
            v-b-tooltip.hover
            title="Editar"
            class="editBtn"
            :disabled="globalDisable"
            @click="editCompareciente(item)"
          >
            <b-icon-pencil />
          </b-button>
          <b-button
            v-if="!item.representante"
            variant="danger"
            size="sm"
            v-b-tooltip.hover
            title="Eliminar"
            :disabled="globalDisable"
            @click="predeleteComparreciente(item.index)"
          >
            <b-icon-trash />
          </b-button>
        </template>
      </b-table>
    </div>

    <div class="mt-4">
      <div>
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import AgregaSolicitante from "@/components/AgregaSolicitante.vue";

import { useComparecientesComboStore } from "@/stores";
import { onMounted, ref } from "vue";

export default {
  name: "SolicitantesNotificaciones",

  components: {
    AgregaSolicitante,
  },

  props: {
    notificacion: { type: Object },
  },

  setup() {
    const comparecientesComboStore = useComparecientesComboStore();

    onMounted(async () => {
      await comparecientesComboStore.fetchCombo();
    });

    return { comparecientesComboStore };
  },

  data() {
    return {
      selectedSolicitante: null,
      currentCompareciente: null,
      currentComparecienteId: null,

      solicitanteToAdd: 2,
      comparecienteIsAdded: false,
      moralData: [],
    };
  },
  computed: {
    fieldsCuadro() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        { key: "persona", label: "Persona", class: "text-center" },
        // { key: "principalsymbol", label: "Principal", class: "text-center" },
        // { key: "representadanombre", label: "Representa A:", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    canAddSolicitanteComputed() {
      return this.notificacion.solicitantes.length === 0;
    },
    globalDisable() {
      return this.notificacion.id_estatus == 7;
    }
  },

  watch: {
    currentCompareciente: function (newVal) {
      this.currentCompareciente.principal = true;
    },
    notificacion: {
      handler: function (newVal, oldVal) {
        const solicitantes = newVal.solicitantes;

        if (solicitantes.length === 0) {
          this.solicitanteToAdd = 2;

          return;
        }

        if (solicitantes.length === 1) {
          solicitantes[0].principal = true;
          solicitantes[0].principalsymbol = "✓";

          if (solicitantes[0].persona === "Física") {
            this.solicitanteToAdd = 1;
            solicitantes[0].representada = null;
            // solicitantes[0].representante = true;
          } else if (solicitantes[0].persona === "Moral") {
            this.solicitanteToAdd = 0;
            solicitantes[0].representada = null;
          }

          return;
        }

        if (solicitantes.length >= 1) {
          const moralIndex = solicitantes.findIndex((s) => s.persona === "Moral");

          if (moralIndex === -1) {
            this.notificacion.solicitantes = [];
            this.solicitanteToAdd = 2;

            return;
          }

          if (solicitantes.length === 2) {
            this.solicitanteToAdd = 0;
          }

          solicitantes.forEach((s) => {
            if (s.persona === "Física") {
              s.principal = false;
              s.principalsymbol = null;
            }
            if (s.persona === "Moral") {
              s.principal = true;
              s.principalsymbol = "✓";
            }
          });
        }
      },
      deep: true,
    },
    comparecienteIsEmpty() {
      return Object.keys(this.currentCompareciente).length === 0;
    },
    selectedSolicitante: "selectSolicitantes",
  },

  methods: {
    displaytext(item) {
      if (item.persona === "Moral") {
        return item.denominacion_social;
      } else if (item.persona === "Física") {
        return `${item.nombre} ${item.paterno} ${item.materno || ""}`.trimEnd();
      }
    },

    selectSolicitantes(val, oldVal) {
      if (!this.selectedSolicitante) {
        return;
      }

      const index = val;
      const _solicitante = this.comparecientesComboStore.comparecientes[index - 1];
      const solicitanteToAdd = {
        id: _solicitante.id,
        cliente_id: _solicitante.cliente_id,
        nombre: _solicitante.nombre,
        paterno: _solicitante.paterno,
        materno: _solicitante.materno,
        denominacion_social: _solicitante.denominacion_social,
        persona: _solicitante.persona,
        actua_derecho_propio: true,
        existente: true,
      };

      _solicitante.index = this.notificacion.solicitantes.length + 1;

      this.notificacion.solicitantes.push(solicitanteToAdd);

      this.selectedSolicitante = null;
    },

    addCompareciente() {
      this.currentCompareciente = {
        actua_derecho_propio: true,
      };
      this.$refs["compareciente-modal"].show();
    },

    editCompareciente(item) {
      this.$refs["compareciente-modal"].show();
      this.currentCompareciente = item;
    },

    putCompareciente(solicitante) {
      this.currentCompareciente = structuredClone(solicitante);

      // this.currentCompareciente.persona = this.currentCompareciente.tipoPersona;

      if (this.currentCompareciente.persona === "Física") {
        this.currentCompareciente.nombreCompleto =
          `${this.currentCompareciente.nombre} ${this.currentCompareciente.paterno} ${this.currentCompareciente.materno || ""}`.trim();
      } else {
        this.currentCompareciente.nombreCompleto = this.currentCompareciente.denominacion_social;
      }

      this.notificacion.solicitantes = [];

      if (!this.currentCompareciente.index) {
        this.currentCompareciente.index = this.notificacion.solicitantes.length + 1;

        this.notificacion.solicitantes.push(this.currentCompareciente);
      }

      this.$refs["compareciente-modal"].hide();
      this.comparecienteIsAdded = true;
    },

    predeleteComparreciente(id) {
      this.currentComparecienteId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    deleteCompareciente() {
      this.notificacion.solicitantes.splice(0, this.notificacion.solicitantes.length);
      this.currentCompareciente = {};
      this.$refs["modal-confirm-dialog"].hide();
    },

    onSubmit() {
      this.$emit("submit-form");
    },
  },
};
</script>

<style scoped>
/* .icons-size {
  font-size: 20px;
} */

/* .container>>>.control-label {
  margin-left: 50px;
  width: 350px;
  position: absolute;
  vertical-align: middle;
} */

.container >>> .custom-control-label {
  margin-left: 50px;
  position: absolute;
  margin-top: 40px;
}

.container >>> .control-label-top {
  margin-top: 0px !important;
  margin-left: 50px;
  text-align: left;
  width: 200px;
}

/* .container>>>.form-control {
  width: 80px;
  margin-left: 400px;
  position: absolute;
  vertical-align: middle;
} */

/* .container>>>.custom-select {
  width: 350px;
  margin-left: 100px;
  vertical-align: middle;
} */

/* .container>>>.long {
  width: 650px !important;
  margin-left: 50px;
} */

.container >>> .form-check-sign {
  margin-top: 15px;
  position: absolute;
}

.check-label-pers {
  margin-left: 45px;
  margin-top: 20px;
  position: absolute;
}

.accordion-container {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.accordion-item {
  border-top: 1px solid #e0e0e0;
}

.accordion-item:first-of-type {
  border-top: none;
}

.accordion-header {
  background-color: #f7f7f7;
  padding: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
}

.accordion-header:hover {
  background-color: #e0e0e0;
}

.accordion-body {
  padding: 20px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
}

.select-container {
  margin-top: 20px;
}

.custom-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.custom-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
}
</style>
